// usePageSwitch.js
import { useState, useCallback } from "react";

export const usePageSwitch = ({ pageList, defaultPage, onPageChange }) => {
  const pageIndices = pageList.reduce((acc, p, i) => ({ ...acc, [p]: i }), {});
  const [currentPage, setCurrentPage] = useState(defaultPage);
  const [visibility, setVisibility] = useState(
    pageList.reduce((acc, p) => ({ ...acc, [p]: false }), {})
  );
  const [taX, setTaX] = useState(0);
  const [taR, setTaR] = useState(0);
  const [isTaExist, setIsTaExist] = useState(false);
  const [shouldHeadStyle2Active, setShouldHeadStyle2Active] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  const setPageVisibility = useCallback((page, isVisible) => {
    setVisibility(prev => ({
      ...prev,
      [page]: isVisible
    }));
  }, []);

  const switchPage = useCallback(
    (targetPage) => {
      if (isAnimating || targetPage === currentPage) return;

      const currentIdx = pageIndices[currentPage];
      const targetIdx = pageIndices[targetPage];
      if (targetIdx === undefined) return;

      const direction = targetIdx > currentIdx ? "forward" : "backward";
      setIsAnimating(true);

      const targetHeadStyle = targetPage !== pageList[0];

      if (direction === "forward") {
        setTaX(0);
        setTaR(0);
        setIsTaExist(true);
        setTimeout(() => setTaX(100), 10);
        setTimeout(() => setShouldHeadStyle2Active(targetHeadStyle), 100);
        setTimeout(() => {
          setVisibility((prev) => ({
            ...prev,
            [currentPage]: false,
            [targetPage]: true,
          }));
          setCurrentPage(targetPage);
          setTaR(100);
          setTimeout(() => {
            setIsTaExist(false);
            setIsAnimating(false);
          }, 160);
        }, 160);
      } else {
        setTaX(100);
        setTaR(100);
        setIsTaExist(true);
        setShouldHeadStyle2Active(targetHeadStyle);
        setTimeout(() => setTaR(0), 10);
        setTimeout(() => {
          setVisibility((prev) => ({
            ...prev,
            [currentPage]: false,
            [targetPage]: true,
          }));
          setCurrentPage(targetPage);
          setTaX(0);
          setTimeout(() => {
            setIsTaExist(false);
            setIsAnimating(false);
          }, 160);
        }, 160);
      }

      if (onPageChange) onPageChange(targetPage);
    },
    [currentPage, isAnimating, onPageChange, pageIndices, pageList]
  );

  return {
    currentPage,
    visibility,
    isTaExist,
    taX,
    taR,
    shouldHeadStyle2Active,
    switchPage,
    isAnimating,
    setPageVisibility, // 添加这个方法
  };
};